<script>
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import opersonel from "@/models/opersonel";
import forminput from "@/router/views/FormComponet/forminput.vue";

import moment from "moment";

export default {
  mixins: [Api, Sabit, opersonel],
  page: {
    title: "",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    forminput,
    
  },
  data() {
    return {
      title: this.$t("ODuyuru.Title"),
      items: [
        {
          text: this.$t("ODuyuru.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("ODuyuru.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      FormData: {},
      DataUpdate: "",
      AddEdit: "",
    };
  },

  methods: {
    Get() {},
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        this.FormData.Adsoyad = this.FormData.Ad + " " + this.FormData.Soyad;
        delete this.FormData.PbsAtanmaSebebi;
        delete this.FormData.PbsAtanmaTipi;
        this.FormData.Kisiselemail = this.FormData.Eposta;

            this.FormData.Ceptelefonu = "05311111111";
        this.Post("opersonel", this.FormData).then((res) => {
          if (res.Succeeded == true) {
            this.FormData = { ...this.opersonelData };

            this.$emit("TableUpdate");
          }
        });
      }
    },
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
this.FormData = { ...this.opersonelData };

    this.ActionsFilterGet({
      Service: "pbsunvantip",
      Page: Page,
      Filter: "&",
    }).then((res) => {
      this.FormData.Unvantipiid = res.Data[0].Id;
    });


         this.ActionsFilterGet({
          Service: "pbsunvanalttip",
             Page:Page,
          Filter: "",
        }).then((res) => {
                    this.FormData.Unvanalttipid = res.Data[0].Id 
                            this.ActionsSingleGet({
          Service: "PbsKurumSicil/GetByUnvanAltTipId",
          Id: res.Data[0].Id ,
        }).then((response) => {
         this.FormData.Kurumsicili = response.Message;
        });

        });
    this.ActionsGet({  
      Service: "ouyruk",
      Page:Page,
    }).then((res) => { 
             this.FormData.Uyrukid = res.Data[0].Id 
   
    }); 
    this.ActionsFilterGet({ 
      Service: "PbsAtanmaSekilleri",
      Page:Page,
      Filter: "",
    }).then((res) => {
                this.FormData.PbsAtanmaSekliId = res.Data[0].Id 

    });

    this.ActionsFilterGet({ 
      Service: "PbsAtanmaTurleri",
      Page:Page,
      Filter: "",
    }).then((res) => {
                this.FormData.PbsAtanmaTuruId = res.Data[0].Id 

    });  
    this.ActionsFilterGet({ 
      Service: "PbsAtanmaMaddeleri",
      Page:Page,
      Filter: "",
    }).then((res) => {
              this.FormData.PbsAtanmaMaddesiId = res.Data[0].Id 

    }); 
    
    this.ActionsGet({ Service: "obirim",       Page:Page, Filter: "" }).then((res) => {
              this.FormData.Defaultbirimid = res.Data[0].Id 
  
    }); 
    


    this.ActionsFilterGet({  
      Service: "okeyvalues",
      Page:Page,
      Filter: "&Tip=3",
    }).then((res) => {
          this.FormData.Medenihalid = res.Data[0].Id 

    }); 

    this.ActionsFilterGet({  
      Service: "okeyvalues",
      Page:Page,
      Filter: "&Tip=192",
    }).then((res) => {
             this.FormData.Kangrubu = res.Data[0].Id 
 
    }); 


  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <Form @submit.prevent="onSubmit">
            <div class="row mb-2">
              <div class="col-sm-12">


                <div class="row mb-3">

                  <forminput
                    class="col-md-6"
                    :FormDataType="FormDataType.Ad"
                    :Value="FormData.Ad"
                    :v="$v.FormData.Ad"
                    @input="FormData.Ad = $event"
                  />

                             <forminput
                    class="col-md-6"
                    :FormDataType="FormDataType.Soyad"
                    :Value="FormData.Soyad"
                    :v="$v.FormData.Soyad"
                    @input="FormData.Soyad = $event"
                  />
                </div>

                <div class="row mb-3">
                        <forminput
                    class="col-md-6"
                    :FormDataType="FormDataType.Tckimlikno"
                    :Value="FormData.Tckimlikno"
                    :v="$v.FormData.Tckimlikno"
                    @input="FormData.Tckimlikno = $event"
                  />
              <forminput
                    class="col-md-6"
                    :FormDataType="FormDataType.Eposta"
                    :Value="FormData.Eposta"
                    :v="$v.FormData.Eposta"
                    @input="FormData.Eposta = $event"
                  />
 
                </div>

                <!-- 6. Satır -->
                <div class="row mb-3">
    

     
                </div>

   
                <div class="row mt-4">
                  <button class="btn btn-primary" type="submit">
                    Kaydet
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
